<template>
    <small class="ses-illu">
      {{types[type].text}} <i><img src="/api/public/img/img.jpg"></i>
      <img :src="'/api/public/img/'+types[type].img+'?v=6'" :class="align">
    </small>
</template>
<script>
export default {
  name: "ses-tooltip",
  data() {
    return {
      types : {
        'illu-1' : { text: 'Illustration 1', img: 'illustration1.png' },
        'illu-2' : { text: 'Illustration 2', img: 'illustration2.png' },
        'illu-3' : { text: 'Illustration 3', img: 'illustration3.jpg' },
        'illu-4' : { text: 'Illustration 4', img: 'illustration4.png' },
        'illu-B4' : { text: 'Illustration B4', img: 'illustrationB4.jpg' },
        'illu-B5' : { text: 'Illustration B5', img: 'illustrationB5.jpg' },
        'illu-5' : { text: 'Illustration 5', img: 'illustration5.png' },
        'illu-6' : { text: 'Illustration 6', img: 'illustration-shaft.png' },

        'illu-B8' : { text: 'ILL.8', img: 'illustrationB8.jpg' },
        'illu-B9' : { text: 'ILL.9', img: 'illustrationB9.jpg' },
        'illu-B10' : { text: 'ILL.10', img: 'illustrationB10.jpg' },

        'illu-ab1' : { text: 'Illustration AB1', img: 'illustrationAB1.jpg' },

        'illu-dbg' : { text: 'ill.dbg', img: 'illustration-dbg.jpg' },

        'illu-hc1' : { text: 'ill', img: 'illustration-hc1.jpg' },

        'illu-S1' : { text: 'Illustration ST', img: 'illustration-S1.png' },

        'illu-ds1' : { text: 'ill.1', img: 'illustration-ds1.jpg' },
        'illu-ds2' : { text: 'ill.2', img: 'illustration-ds2.jpg' },
        'illu-ds3' : { text: 'ill.3', img: 'illustration-ds3.jpg' },
        'illu-ds4' : { text: 'ill.4', img: 'illustration-ds4.jpg' },
        'illu-ds5' : { text: 'ill.5', img: 'illustration-ds5.png' },
        'illu-ds6' : { text: 'ill.6', img: 'illustration-ds6.jpg' },

        'illu-idec' : { text: 'IDEC Colors', img: 'illustration-idec.jpg' },

        'illu-dura' : { text: 'Illustration DL', img: 'illustrationDuraLift.jpg' },
        'illu-S1new' : { text: 'Illustration ST', img: 'illustration-S1x810.png' },
        'illu-def-slab' : { text: 'Illustration 4', img: 'illustration-def-slab.PNG' },
      }
    };
  },
  props: {
    type: {
      type: String,
      default: "",
      description: "Illustration type."
    },
    align: {
      img: String,
      default: "left",
      description: "Align Tooltip"
    },
  }
};
</script>
<style>
  .siw { position: relative; }
  .ses-illu { display: inline-block; color: #00F; cursor: pointer; white-space: nowrap; }
  .ses-illu > img { display: none; position: absolute; top: 100%; left: 0px; z-index: 9999; }
  .ses-illu > img.top { top: auto; bottom: 100%; }
  .ses-illu > img.right { top: 100%; left: auto; right: 0px; }
  .ses-illu:hover > img { display: block; }
</style>
